// This must be the first line in src/index.js
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React, {Suspense} from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import router from './routes';
import store from './store';
import { ConfigProvider } from 'antd';
import '@/less/global.less';
import zh_CN from 'antd/es/locale/zh_CN';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    // <Suspense>
      <Provider store={store}>
        <ConfigProvider locale={zh_CN}>
        <RouterProvider router={router} />
        </ConfigProvider>
      </Provider>
    // </Suspense>
);
